<canvas baseChart
        [datasets]="data"
        [labels]="labels"
        [options]="options"
        [plugins]="plugins"
        [legend]="legend"
        [chartType]="type">
</canvas>
